export default class Slideshow {
  
  constructor($slideshow, options) {
    var currentIndex = $slideshow.getAttribute('data-start-index') != null ? Number($slideshow.getAttribute('data-start-index')) : 0;
    var isAutoplay = $slideshow.getAttribute('data-autoplay') != null ? true : false;
    var $slides    = $slideshow.querySelectorAll('[data-slide]');
    var $next      = $slideshow.querySelectorAll('[data-next]');
    var $prev      = $slideshow.querySelectorAll('[data-prev]');
    var $counters      = $slideshow.querySelectorAll('[data-counter]');

    function onNextDown(e) {
      updateSlides( currentIndex+1 )
    }
    function onPrevDown(e) {
      updateSlides( currentIndex-1 )
    }
    this.destroy = function() {
        $next.forEach(function($el){
          $el.removeEventListener('click',onNextDown)
        }); 
        $prev.forEach(function($el){
          $el.removeEventListener('click',onPrevDown)
        });
    }
    function updateSlides(idx) {


      currentIndex = idx > 0 ? idx : 0;
      currentIndex = currentIndex % $slides.length;


      options.onChange && options.onChange( currentIndex )

      $counters.forEach((el)=>{
        el.innerHTML = (currentIndex+1)+'/'+$slides.length
      })

      $slides.forEach(function($slide, slideIndex){
        $slide.classList[currentIndex == slideIndex ? 'add':'remove']('is-active');
        $slide.classList[slideIndex < currentIndex - 2 ? 'add':'remove']('is-hide-prev');
        $slide.classList[slideIndex < currentIndex - 1 ? 'add':'remove']('is-far-prev');
        $slide.classList[slideIndex < currentIndex     ? 'add':'remove']('is-prev');
        $slide.classList[slideIndex > currentIndex     ? 'add':'remove']('is-next');
        $slide.classList[slideIndex > currentIndex + 1 ? 'add':'remove']('is-far-next');
        $slide.classList[slideIndex > currentIndex + 2 ? 'add':'remove']('is-hide-next');
      });
    }
    $next.forEach(function($el){
      $el.addEventListener('click',onNextDown)
    }); 
    $prev.forEach(function($el){
      $el.addEventListener('click',onPrevDown)
    });
    
    updateSlides( currentIndex )

    var autoplayStartDate = Date.now();
    function autoplay() {
        autoplayStartDate = Date.now();
        setTimeout(function(){
            updateSlides( currentIndex+1 );
            autoplay()
        }, 5000)
    }
    if (isAutoplay) {
      autoplay()
    }
  }
}